module.exports = __webpack_public_path__ + "static/media/indeks.81b37803.svg";